export default function (element, data) {
    element.addEventListener("click", function (event) {
        window.dispatchEvent(new CustomEvent("slidenextbutton"));
    });
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary
